import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { customAPI } from "../services/api";
import { useEffect, useState } from "react";
import moment from "moment";


const getInvoiceItem = (id, invoiceId, token) =>
    customAPI(token).get(`api/Reports/${id}/Invoices/` + invoiceId + "/Details").then((res) => {
        return res?.data;
    });
const normalizer = (item) => {
    const newItem = {
        id: item.id,
        invoiceNumber: item.invoiceNumber,
        invoiceType: item.invoiceType,
        reference: item.reference,
        attention: item.attention,
        amount: item.amount,
        amount_Credit: item.amount_Credit,
        amount_Paid: item.amount_Paid,
        amount_Dispute: item.amount_Dispute,
        ccy: item.ccy,
        status: item.status,
        amount_Due: item.amount_Due,
        date: item.date ? moment(item.date).format("MM/DD/YYYY") : "",
        amount_Undispute: item.amount_Undispute,
    };
    return newItem;
};
const useInvoice = ({ id = null, invoiceId = null }) => {
    const { token } = useSelector((store) => store.auth);
    const [detail, setDetail] = useState({})

    const { data } = useQuery(
        `GET-INVOICE-ITEM-${id}`,
        () => getInvoiceItem(id, invoiceId, token),
        {
            enabled: !!id,
        }
    );
    useEffect(() => {
        if (Object.keys(data || {})?.length > 0) {
            const normlizedData = normalizer(data);
            if (normlizedData) setDetail(normlizedData);
            else {
                setDetail({});
            }
        }
    }, [data]);

    return {
        detail,
    };
};

export default useInvoice;
